import React from 'react';

/**
 * LinkProps defines the types for the Link component props.
 */
interface LinkProps {
  href?: string;
  label?: string;
  children?: React.ReactNode;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  [key: string]: any;
}

const Link: React.FC<LinkProps> = ({
  href,
  label,
  children,
  className,
  size = 'small',
  ...props
}) => {
  // Define default size styles
  const sizeClasses = {
    small: 'text-sm px-1 py-1',
    medium: 'text-base px-4 py-2',
    large: 'text-lg px-6 py-3',
  };

  // Combine className with size and base styles
  const linkClassName = `text-primary hover:underline transition-colors px-1 duration-200 ${sizeClasses[size] || ''} ${className || ''}`;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Prevent default navigation behavior
    e.preventDefault();

    // Standard navigation using window.location
    window.location.href = href || '';
  };

  return href ? (
    <a href={href} className={linkClassName} onClick={handleClick} {...props}>
      {label || children}
    </a>
  ) : (
    <span className={linkClassName} onClick={handleClick} {...props}>
      {label || children}
    </span>
  );
};

export default Link;
